export const REPORT_EXPORT_TYPES = {
  GENERATE_REPORT: "GENERATE_REPORT",
  EXPORT_TO_MAIL: "EXPORT_TO_MAIL",
};

export type REPORT_EXPORT_TYPES_TYPE =
  (typeof REPORT_EXPORT_TYPES)[keyof typeof REPORT_EXPORT_TYPES];
